import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import sectionService from "../../../services/sectionService";
import ActionCell from "./components/ActionCell";
import MDBadge from "../../../components/MDBadge";
import MDSnackbar from "../../../components/MDSnackbar";

function SectionList() {
  const [sections, setSections] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    color: "info",
    title: "",
    content: "",
  });

  const closeNotification = () => setNotification({ ...notification, open: false });

  useEffect(() => {
    fetchSections(page, limit, search);
  }, [page, limit, search]);

  const fetchSections = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await sectionService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "name",
        sort: "order",
        select: "name,color,order,is_active"
      });
      setSections(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching sections:", error);
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    return status ? "success" : "secondary";
  };

  const columns = [
    { Header: "Nombre", accessor: "name", align: "left" },
    { Header: "Color", accessor: "color", align: "left" },
    { Header: "Orden", accessor: "order", align: "left" },
    { Header: "Estado", accessor: "is_active", align: "center" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = sections.map((section) => ({
    name: <MDTypography variant="button" fontWeight="medium">{section.name}</MDTypography>,
    color: <MDTypography variant="caption" sx={{ backgroundColor: section.color, color: "white", padding: "2px 8px", borderRadius: "4px" }}>{section.color}</MDTypography>,
    order: <MDTypography variant="caption">{section.order}</MDTypography>,
    is_active: <MDBadge badgeContent={section.is_active ? "Activo" : "Inactivo"} color={getStatusColor(section.is_active)} variant="gradient" size="sm" />,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={section._id} action="details" icon="visibility" color="info" />
        <ActionCell id={section._id} action="edit" icon="edit" color="info" />
        <ActionCell id={section._id} action="delete" icon="delete" color="primary" onDelete={fetchSections} />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <MDButton
          component={Link}
          to="/sections/new"
          variant="gradient"
          color="info"
        >
          Nuevo
        </MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Secciones</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDSnackbar
        color={notification.color}
        icon={notification.color === "error" ? "warning" : "check"}
        title={notification.title}
        content={notification.content}
        dateTime="Ahora"
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />
      <Footer />
    </DashboardLayout>
  );
}

export default SectionList;

